import type { SVGProps } from 'react'
const SvgSyTechSolidIot = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd">
			<path d="M12.54 12.43V8a1.14 1.14 0 1 0-1 0v4.42H7.27V9.6a1.14 1.14 0 0 0-.53-2.15 1.14 1.14 0 0 0-.52 2.15v2.83H6a3.82 3.82 0 1 1 1.4-7.38A5.22 5.22 0 0 1 16.84 5a4 4 0 0 1 1.23-.2 3.83 3.83 0 0 1 0 7.66h-.25V9.6a1.14 1.14 0 1 0-1.06 0v2.83z" />
			<path
				fillOpacity={0.24}
				d="M7.27 15.39a2 2 0 0 1 1.54 2 2.07 2.07 0 1 1-2.59-2v-2.96h1zm-.53 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m11.08-3a2.07 2.07 0 1 1-1.06 0v-2.95h1.06zm-.53 3a1 1 0 0 0 .39-1.94 1 1 0 1 0-.39 1.94m-4.75-.43a2.06 2.06 0 1 1-1 0v-5.5h1.06zm-.54 3a1 1 0 1 0-.93-.62 1 1 0 0 0 .93.6z"
			/>
		</g>
	</svg>
)
export default SvgSyTechSolidIot
